import { Collapse, Button, Row, Col, Space, Typography, Modal, Divider } from "antd";
import { DeleteOutlined, IssuesCloseOutlined } from "@ant-design/icons";
import axios from "axios";
import { useEffect, useState } from "react";
import DataGroup from "./DataGroup";
import DataItem from "./DataItem2";
import Subtitle from "./Subtitle";
import AddVisitForm from "./forms/general/AddVisitForm";
import moment from "moment";
import { useAuth } from "../../layout/auth";
import "moment/locale/es";
moment.locale("es-mx");

export default function VisitPreview(props) {
  const { id, verification, visits, setVisits } = props;
  const [AddVisitFormVisible, setAddVisitFormVisible] = useState(false);
  const [tipo, setTipo] = useState();
  const [timeRange, setTimeRange] = useState();
  const auth = useAuth();

  useEffect(() => {
    if (verification) {
      if (verification.TipoVerificacionID === 5 && verification.Capacidad === 0) {
        setTipo("vieja");
      } else if (verification.TipoVerificacionID === 5 && verification.Capacidad > 0) {
        setTipo("viejatro");
      } else if (verification.AlcanceVerificacion < 100) {
        setTipo("menor100");
      } else if (verification.AlcanceVerificacion > 100) {
        setTipo("mayor100");
      }
    }
  }, [verification]);

  useEffect(() => {
    // Fetch time range data with UID
    if (auth && auth.UID) {
      axios
        .get(`${process.env.REACT_APP_API_URL}/usuarios/rango`, {
          params: { u: auth.UID },
        })
        .then((res) => {
          setTimeRange(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [id, auth]);

  const handleDeleteVisit = (visitId) => {
    Modal.confirm({
      title: "Eliminar visita",
      content: "¿Estás seguro de que deseas eliminar esta visita?",
      okText: "Borrar",
      okType: "danger",
      cancelText: "No",
      onOk: () => {
        axios
          .delete(`${process.env.REACT_APP_API_URL}/visitas/${visitId}`)
          .then((res) => {
            axios.get(`${process.env.REACT_APP_API_URL}/visitas/${id}`).then((res) => {
              setVisits(res.data);
            });
          })
          .catch((err) => {
            console.log(err);
          });
      },
    });
  };

  return (
    <>
      <Row gutter={[16, 16]} style={{ marginBottom: "16px" }}>
        <Col span={24} style={{ textAlign: "right" }}>
          <Space>
            <Button
              type="primary"
              onClick={() => {
                setAddVisitFormVisible(true);
              }}
            >
              Agregar visita
            </Button>
          </Space>
        </Col>
      </Row>
      <Collapse bordered={false} accordion expandIconPosition="right">
        {visits &&
          visits.map((visit, index) => (
            <Collapse.Panel
              key={index}
              header={
                <div>
                  <IssuesCloseOutlined
                    style={{
                      fontSize: "20px",
                      borderRadius: "50%",
                      border: "1px solid #1890ff",
                      padding: "5px",
                      backgroundColor: "#fff",
                    }}
                  />
                  <span style={{ marginLeft: "10px", fontWeight: "500" }}>Visita {index + 1}</span>
                  <span
                    style={{
                      marginLeft: "12px",
                      color: "#595959",
                      fontSize: "13px",
                    }}
                  >
                    <span style={{ marginRight: "16px" }}>
                      📅{" "}
                      {visit.FechaVisita ? (
                        moment(visit.FechaVisita, "YYYY-MM-DD").format("LL")
                      ) : (
                        <span style={{ color: "#bfbfbf", fontStyle: "italic" }}>Sin fecha</span>
                      )}
                    </span>
                    <span>
                      🕐 {visit.HoraInicio ? moment(visit.HoraInicio, "HH:mm").format("HH:mm") : "--:--"}
                      {" - "}
                      {visit.HoraTermino ? moment(visit.HoraTermino, "HH:mm").format("HH:mm") : "--:--"}
                    </span>
                  </span>
                </div>
              }
              extra={
                <Button
                  type="default"
                  shape="circle"
                  icon={<DeleteOutlined />}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDeleteVisit(visit.VisitaID);
                  }}
                />
              }
            >
              <Subtitle title="Desarrollo de la visita" marginTop={16} />
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={24} md={24} lg={16} xl={16}>
                  <DataGroup mainData={visit} setMainData={setVisits} formName={"Desarrollo de la visita"} verification={verification}>
                    <DataItem
                      keyName="Lista de inspección"
                      value={visit.ListaInspeccion}
                      valueType="longString"
                      fieldWidth={6}
                      button={`Descargar Lista ${visit.ListaTipo}`}
                      buttonFunction={() => {
                        axios({
                          method: "get",
                          url:
                            visit.ListaTipo === "Fija"
                              ? `${process.env.REACT_APP_API_URL}/formatos/listainspeccion/fija/${visit.ListaInspeccion}/${visit.VisitaID}`
                              : `${process.env.REACT_APP_API_URL}/formatos/listainspeccion/variable/${tipo}/${visit.ListaInspeccion}/${visit.VisitaID}`,
                          responseType: "blob",
                        })
                          .then((res) => {
                            const fileName = `Lista de inspección ${new Date().getTime()}.docx`;
                            const blob = new Blob([res.data], {
                              type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                            });
                            const link = document.createElement("a");
                            link.href = window.URL.createObjectURL(blob);
                            link.download = fileName;
                            link.click();
                          })
                          .catch((err) => {
                            console.log(err);
                          });
                      }}
                    />
                    <DataItem keyName="Objeto de la visita" value={visit.ObjetoVisita} valueType="longString" />
                    <DataItem keyName="Circunstancia de la visita" value={visit.CircunstanciaVisita} valueType="longString" />
                    <DataItem keyName="No conformidades del encargado" value={visit.NoConformidadesEncargado} valueType="longString" />
                    <DataItem keyName="Observaciones del encargado" value={visit.ObservacionesEncargado} valueType="longString" />
                    <DataItem keyName="Acciones" value={visit.Acciones} valueType="longString" fieldWidth={4} />
                  </DataGroup>
                </Col>
              </Row>
              <Subtitle title="Pruebas realizadas" marginTop={16} />
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={24} md={24} lg={16} xl={16}>
                  <DataGroup mainData={visit} setMainData={setVisits} formName="Pruebas" verification={verification}>
                    <DataItem
                      keyName="Resultado de la prueba de Resistencia de aislamiento"
                      value={visit.ResResistenciaAislamiento}
                      valueType="longString"
                      fieldWidth={4}
                    />
                    <DataItem
                      keyName="Equipo para la prueba de Resistencia de aislamiento"
                      value={visit.EqResistenciaAislamiento}
                      valueType="longString"
                      fieldWidth={4}
                    />
                    <DataItem
                      keyName="Resultado de prueba de Resistencia de las tierras físicas"
                      value={visit.ResResistenciaTierraFisica}
                      valueType="longString"
                      fieldWidth={4}
                    />
                    <DataItem
                      keyName="Equipo para la prueba de Resistencia de las tierras físicas"
                      value={visit.EqResistenciaTierraFisica}
                      valueType="longString"
                      fieldWidth={4}
                    />
                    <DataItem
                      keyName="Resultado de la prueba de Continuidad eléctrica"
                      value={visit.ResContinuidadElectrica}
                      valueType="longString"
                      fieldWidth={4}
                    />
                    <DataItem
                      keyName="Equipo para la prueba de Continuidad eléctrica"
                      value={visit.EqContinuidadElectrica}
                      valueType="longString"
                      fieldWidth={4}
                    />
                    <DataItem
                      keyName="Resultado de la prueba de Polaridad de los contactos"
                      value={visit.ResPolaridadContactos}
                      valueType="longString"
                      fieldWidth={4}
                    />
                    {/* <DataItem
                      keyName="Equipo para la prueba de Polaridad de los contactos"
                      value={visit.EqPolaridadContactos}
                      valueType="longString"
                      fieldWidth={4}
                    /> */}
                  </DataGroup>
                </Col>
              </Row>
              <Subtitle title="Testigos" marginTop={16} />
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={24} md={24} lg={16} xl={8}>
                  <DataGroup
                    title={!visit?.NombreCompletoPT1 ? "TESTIGO 1" : `TESTIGO 1: ${visit?.NombreCompletoPT1}`}
                    subtitle={
                      visit?.TipoPersonaPT1 && visit?.NacionalidadPT1
                        ? "Persona " + visit?.TipoPersonaPT1 + ", " + visit?.NacionalidadPT1
                        : null
                    }
                    mainData={visit}
                    setMainData={setVisits}
                    formName="Testigo 1"
                    verification={verification}
                  >
                    <DataItem
                      keyName={visit.TipoDatoPT1 ? visit.TipoDatoPT1 : "Tipo de identificación"}
                      value={visit.DatoPT1_T}
                      valueType="string"
                      fieldWidth={4}
                    />
                    <DataItem keyName="Domicilio" value={visit.DomicilioPT1_T} valueType="string" fieldWidth={4} />
                  </DataGroup>
                </Col>
                <Col xs={24} sm={24} md={24} lg={16} xl={8}>
                  <DataGroup
                    title={!visit?.NombreCompletoPT2 ? "TESTIGO 2" : `TESTIGO 2: ${visit?.NombreCompletoPT2}`}
                    subtitle={
                      visit?.TipoPersonaPT2 && visit?.NacionalidadPT2
                        ? "Persona " + visit?.TipoPersonaPT2 + ", " + visit?.NacionalidadPT2
                        : null
                    }
                    mainData={visit}
                    setMainData={setVisits}
                    formName="Testigo 2"
                    verification={verification}
                  >
                    <DataItem
                      keyName={visit.TipoDatoPT2 ? visit.TipoDatoPT2 : "Tipo de identificación"}
                      value={visit.DatoPT2_T}
                      valueType="string"
                      fieldWidth={4}
                    />
                    <DataItem keyName="Domicilio" value={visit.DomicilioPT2_T} valueType="string" fieldWidth={4} />
                  </DataGroup>
                </Col>
              </Row>
            </Collapse.Panel>
          ))}
      </Collapse>
      {timeRange && timeRange.length > 0 && (
        <AddVisitForm
          id={id}
          setVisits={setVisits}
          formVisibility={AddVisitFormVisible}
          setFormVisibility={setAddVisitFormVisible}
          timeRange={timeRange}
          verification={verification}
        />
      )}
    </>
  );
}
